import { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  Badge,
  Box,
  Button,
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  Delete,
  Edit,
  Add,
  Save,
} from "@mui/icons-material";
import MenuListeAPI from "../../../apis/OB/Get/MenuListeAPI";
import MenuUpdateAPI, {
  MenuUpdateRequest,
} from "../../../apis/OB/SaveApi/MenuUpdateAPI";
import MenuPopUp from "./MenuPopup";
import { toast } from "react-toastify";

const AdminMenuControl = () => {
  const [menuListe, setMenuListe] = useState<any[]>([]);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedSqId, setSelectedSqId] = useState<number | null>(null);
  const [typePopup, setTypePopup] = useState<string | null>(null);
  const [selectedItem, setSelectedItem] = useState<any | null>(null);
  const [sqIdLists, setSqIdLists] = useState<any[]>([]);
  const [isDirty, setIsDirty] = useState(false);
  const [kayitBasariliMi, setKayitBasariliMi] = useState(false);

  useEffect(() => {
    if (!isPopupVisible) {
      setSelectedSqId(null);
      setTypePopup(null);
      fetchMenuList();
    }
  }, [isPopupVisible]);
  useEffect(() => {
    fetchMenuList();
  }, [kayitBasariliMi]);
  const fetchMenuList = async () => {
    try {
      const response = await MenuListeAPI.getAdminMenuListe(
        undefined,
        undefined
      );
      console.log("response:", response);

      // Menüleri sıralayın
      const ordered = response.data.sort(
        (a: any, b: any) => a.menuSirasi - b.menuSirasi
      );

      // Yalnızca panel değeri 1 olan menüleri filtreleyin
      const filteredMenu = ordered.filter((x: any) => x.panel === 1);

      // Menüyü organize et
      const structuredList = organizeMenu(filteredMenu);

      console.log("Ordered list:", ordered);
      console.log("Structured list:", structuredList);

      setSqIdLists(structuredList);
    } catch (error) {
      console.error(error);
    }
  };

  const handleToggleSubMenu = (index: number) => {
    setSqIdLists((prev) =>
      prev.map((menu: any) =>
        menu.ustBaslik.sqId === index
          ? {
              ...menu,
              ustBaslik: { ...menu.ustBaslik, open: !menu.ustBaslik.open },
            }
          : menu
      )
    );
  };

  const onDragEnd = (result: any) => {
    const { source, destination, type } = result;
    if (!destination) return;

    setIsDirty(true);

    if (type === "MENU") {
      const newMenuListe = Array.from(sqIdLists);
      const [removed] = newMenuListe.splice(source.index, 1);
      newMenuListe.splice(destination.index, 0, removed);

      setSqIdLists(newMenuListe);
    } else {
      const sourceMenuId = parseInt(source.droppableId.split("-")[1]);
      const destinationMenuId = parseInt(destination.droppableId.split("-")[1]);

      const sourceMenu = sqIdLists.find(
        (menu: any) => menu.ustBaslik.sqId === sourceMenuId
      );
      const destinationMenu = sqIdLists.find(
        (menu: any) => menu.ustBaslik.sqId === destinationMenuId
      );

      if (sourceMenu && destinationMenu) {
        const sourceItems = Array.from(sourceMenu.altBasliklar);
        const [movedItem] = sourceItems.splice(source.index, 1);

        if (sourceMenuId === destinationMenuId) {
          sourceItems.splice(destination.index, 0, movedItem);
          setSqIdLists((prev) =>
            prev.map((menu: any) =>
              menu.ustBaslik.sqId === sourceMenuId
                ? { ...menu, altBasliklar: sourceItems }
                : menu
            )
          );
        } else {
          const destinationItems = Array.from(destinationMenu.altBasliklar);
          destinationItems.splice(destination.index, 0, movedItem);

          setSqIdLists((prev) =>
            prev.map((menu: any) =>
              menu.ustBaslik.sqId === sourceMenuId
                ? { ...menu, altBasliklar: sourceItems }
                : menu.ustBaslik.sqId === destinationMenuId
                ? { ...menu, altBasliklar: destinationItems }
                : menu
            )
          );
        }
      }
    }
  };

  const traverseSqIdLists = (sqIdLists: any) => {
    let collectedData: {
      sqId: number;
      siraNo: number;
      parentSiraNo?: number;
    }[] = [];

    sqIdLists.forEach((menu: any, index: number) => {
      collectedData.push({ sqId: menu.ustBaslik.sqId, siraNo: index + 1 });

      menu.altBasliklar.forEach((item: any, itemIndex: number) => {
        collectedData.push({
          sqId: item.sqId,
          siraNo: itemIndex + 1,
          parentSiraNo: index + 1,
        });
      });
    });

    return collectedData;
  };

  const createXmlInputForProcedure = (list: any[]) => {
    let xmlString = `<ROWS>\n`;
    console.log("list:", list);
    list.forEach((item) => {
      xmlString += `  <ROW>\n`;
      xmlString += `    <P_SQ_ID>${item.sqId}</P_SQ_ID>\n`;
      xmlString += `    <P_MENU_SIRASI>${item.siraNo}</P_MENU_SIRASI>\n`;
      xmlString += `  </ROW>\n`;
    });

    xmlString += `</ROWS>`;

    return xmlString;
  };

  const saveMenuOrder = async () => {
    try {
      const updatedList = traverseSqIdLists(sqIdLists);
      const xmlSiraNo = createXmlInputForProcedure(updatedList).toString();
      const request = new MenuUpdateRequest(xmlSiraNo);

      const response = await MenuUpdateAPI.saveMenuUpdateSave(request);
      if (response.data.sonuc === 0) {
        setIsDirty(false);
        toast.success("Menü sıralaması başarıyla güncellendi.");
        fetchMenuList(); // Menü sıralaması güncellendikten sonra yeniden yükleyin
      } else {
        toast.error("Menü sıralaması güncellenemedi.");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleAddSubMenu = (parentId: number) => {
    setSelectedSqId(parentId);
    setTypePopup("ekle");
    setIsPopupVisible(true);
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 2,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={() => {
            setSelectedSqId(null);

            setTypePopup("ekle");
            setIsPopupVisible(true);
          }}
        >
          Ekle
        </Button>
        {isDirty && (
          <Button
            variant="contained"
            color="secondary"
            startIcon={<Save />}
            onClick={saveMenuOrder}
          >
            Kaydet
          </Button>
        )}
      </Box>
      <Paper>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="all-menus" type="MENU">
            {(provided) => (
              <List {...provided.droppableProps} ref={provided.innerRef}>
                {sqIdLists.map((menu: any, index: number) => (
                  <Draggable
                    key={menu.ustBaslik.sqId}
                    draggableId={`menu-${menu.ustBaslik.sqId}`}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <ListItem>
                          <Badge
                          className="me-3"
                            variant="dot"
                            color={
                              menu.ustBaslik.aktifPasif === "A"
                                ? "success"
                                : "error"
                            }
                          >
                            <span>{menu.ustBaslik.baslikAdi}</span>
                          </Badge>
                          <ListItemIcon>
                            <i className={menu.ustBaslik.ikonYolu2}></i>
                          </ListItemIcon>
                          <ListItemText primary={menu.ustBaslik.menuAdi} />
                          <IconButton
                            onClick={() =>
                              handleToggleSubMenu(menu.ustBaslik.sqId)
                            }
                          >
                            {menu.ustBaslik.sayfaLink.includes("anasayfa") ? (
                              menu.ustBaslik.open ? (
                                <ExpandLess />
                              ) : (
                                <ExpandMore />
                              )
                            ) : null}
                          </IconButton>
                          {menu.ustBaslik.sayfaLink.includes("anasayfa") ? (
                            <IconButton
                              onClick={() =>
                                handleAddSubMenu(menu.ustBaslik.sqId)
                              }
                            >
                              <Add />
                            </IconButton>
                          ) : null}
                          {menu.ustBaslik.guncellemeIzni == "E" ? (
                            <>
                              <IconButton
                                onClick={() => {
                                  setSelectedItem(menu.ustBaslik);
                                  setTypePopup("guncelle");
                                  setSelectedSqId(menu.ustBaslik.sqId);
                                  setIsPopupVisible(true);
                                }}
                              >
                                <Edit />
                              </IconButton>
                              <IconButton
                                onClick={() => {
                                  setSelectedItem(menu.ustBaslik);
                                  setTypePopup("sil");
                                  setSelectedSqId(menu.ustBaslik.sqId);
                                  setIsPopupVisible(true);
                                }}
                              >
                                <Delete />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              onClick={() => {
                                setSelectedItem(menu.ustBaslik);
                                setTypePopup("guncelle");
                                setSelectedSqId(menu.ustBaslik.sqId);
                                setIsPopupVisible(true);
                              }}
                            >
                              <Edit />
                            </IconButton>
                          )}
                        </ListItem>
                        <Collapse
                          in={menu.ustBaslik.open}
                          timeout="auto"
                          unmountOnExit
                        >
                          <List component="div" disablePadding>
                            <Droppable
                              droppableId={`items-${menu.ustBaslik.sqId}`}
                              type="ITEM"
                            >
                              {(provided) => (
                                <div
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                >
                                  {menu.altBasliklar.map(
                                    (item: any, itemIndex: number) => (
                                      <Draggable
                                        key={item.sqId}
                                        draggableId={`item-${item.sqId}`}
                                        index={itemIndex}
                                      >
                                        {(provided) => (
                                          <ListItem
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            sx={{ pl: 4 }}
                                          >
                                            <Badge
                          className="me-3"
                            variant="dot"
                            color={
                              item.aktifPasif === "A"
                                ? "success"
                                : "error"
                            }
                          >
                            <span>{menu.ustBaslik.baslikAdi}</span>
                          </Badge>
                                            <ListItemIcon>
                                              <i className={item.ikonYolu2}></i>
                                            </ListItemIcon>
                                            <ListItemText
                                              primary={item.menuAdi}
                                            />
                                            {item.guncellemeIzni == "E" ? (
                                              <>
                                                <IconButton
                                                  onClick={() => {
                                                    setSelectedItem(item);
                                                    setTypePopup("guncelle");
                                                    setSelectedSqId(item.sqId);
                                                    setIsPopupVisible(true);
                                                  }}
                                                >
                                                  <Edit />
                                                </IconButton>
                                                <IconButton
                                                  onClick={() => {
                                                    setSelectedItem(item);
                                                    setTypePopup("sil");
                                                    setSelectedSqId(item.sqId);
                                                    setIsPopupVisible(true);
                                                  }}
                                                >
                                                  <Delete />
                                                </IconButton>
                                              </>
                                            ) : (
                                              <IconButton
                                                onClick={() => {
                                                  setSelectedItem(item);
                                                  setTypePopup("guncelle");
                                                  setSelectedSqId(item.sqId);
                                                  setIsPopupVisible(true);
                                                }}
                                              >
                                                <Edit />
                                              </IconButton>
                                            )}
                                          </ListItem>
                                        )}
                                      </Draggable>
                                    )
                                  )}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </List>
                        </Collapse>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </List>
            )}
          </Droppable>
        </DragDropContext>
      </Paper>
      {isPopupVisible && (
        <MenuPopUp
          item={selectedItem}
          sqId={selectedSqId}
          kayitBasariliMi={setKayitBasariliMi}
          basariliMi={kayitBasariliMi}
          close={setIsPopupVisible}
          type={typePopup}
        />
      )}
    </Box>
  );
};

function organizeMenu(items: any[]) {
  const menuMap: any = {};

  // Öncelikle üst başlıkları (parentId === 0 olanları) sıralı şekilde ekleyelim
  const ustBasliklar = items
    .filter((item) => item.parentId === 0)
    .sort((a, b) => a.menuSirasi - b.menuSirasi);

  ustBasliklar.forEach((item) => {
    menuMap[item.sqId] = {
      ustBaslik: item,
      altBasliklar: [],
    };
  });

  // Alt başlıkları uygun üst başlık sırasına göre ekleyelim
  const altBasliklar = items
    .filter((item) => item.parentId !== 0)
    .sort((a, b) => a.menuSirasi - b.menuSirasi); // Alt başlıkları kendi içinde sıralıyoruz

  altBasliklar.forEach((item) => {
    if (menuMap[item.parentId]) {
      menuMap[item.parentId].altBasliklar.push(item);
    }
  });

  // Üst başlıkların sırasına göre sıralanmış bir dizi döndürelim
  return ustBasliklar.map((item) => menuMap[item.sqId]);
}

export default AdminMenuControl;
